<script lang="ts" setup>
import { apiUrl } from '@apps/main/modules/api/shared/apiQuery';

import { AppSvgIcon } from '@libs/ui';

interface FlightRulesProps {
  token: string;
}
const props = defineProps<FlightRulesProps>();

const domain = apiUrl();
const urlBaggageRulesAndTerms = `${domain}/mvc/Flight/FlightTerms?itineraryCacheId=${props.token}`;
</script>

<template>
  <div class="flight-rules">
    <a
      class="link"
      target="_blank"
      rel="noopener noreferrer"
      :href="urlBaggageRulesAndTerms"
    >
      <span>
        {{ $t('planner.ticket_and_baggage_rules') }}
      </span>
      <AppSvgIcon class="link-icon" name="newTab" size="18" />
    </a>
  </div>
</template>

<style lang="scss" scoped>
.flight-rules {
  margin-top: var(--spacing-32);
  margin-bottom: var(--spacing-8);
  .link {
    display: flex;
    align-items: center;
    color: var(--color);
    text-decoration: underline;

    @include font-link-l;

    .link-icon {
      margin-left: var(--spacing-8);
    }
  }
}
</style>
